export default function MenuConfig({ roleDesc, roleScope, centralisedService }) {
  switch (roleDesc) {
    case "Client":
      if (centralisedService === "1") {
        const itemsBasic = {
          header: {
            self: {},
            items: [],
          },
          aside: {
            self: {},
            items: [
              {
                title: "Task Dashboard",
                root: true,
                icon: "flaticon2-architecture-and-city",
                page: "dashboard",
                bullet: "dot",
              },

              {
                title: "Log out",
                root: true,
                icon: "flaticon2-circular-arrow",
                page: "logout",
              },
            ],
          },
        };
        return itemsBasic;
      } else {
        const itemsBasic = {
          header: {
            self: {},
            items: [],
          },
          aside: {
            self: {},
            items: [
              {
                title: "Dashboard",
                root: true,
                icon: "flaticon2-architecture-and-city",
                page: "dashboard",
                bullet: "dot",
              },
              {
                title: "Search Providers",
                root: true,
                icon: "flaticon2-map",
                bullet: "dot",
                page: "search",
              },
              {
                title: "Bookings",
                root: true,
                icon: "flaticon2-time",
                bullet: "dot",
                page: "bookings",
              },
              {
                title: "Profile",
                root: true,
                icon: "flaticon2-gear",
                bullet: "dot",
                page: "profile",
              },
              {
                title: "Files",
                root: true,
                icon: "flaticon-file",
                bullet: "dot",
                page: "files",
              },
              {
                title: "Log out",
                root: true,
                icon: "flaticon2-circular-arrow",
                page: "logout",
              },
            ],
          },
        };
        return itemsBasic;
      }

    case "Admin":
      // console.log(roleScope)
      if (roleScope !== "Provisional" && roleScope !== "Psychiatrist") {
        const itemsAdmin = {
          header: {
            self: {},
            items: [],
          },
          aside: {
            self: {},
            items: [
              {
                title: "Dashboard",
                root: true,
                icon: "flaticon2-architecture-and-city",
                page: "dashboard",
                bullet: "dot",
              },
              {
                title: "Search",
                root: true,
                icon: "flaticon2-search",
                page: "searchclientdata",
                bullet: "dot",
              },
              {
                title: "Search Bookings",
                root: true,
                icon: "flaticon2-search",
                page: "searchbookingdata",
                bullet: "dot",
              },
              {
                title: "Faxes",
                root: true,
                icon: "flaticon2-paper",
                page: "faxes",
              },
              {
                title: "Interested Providers",
                root: true,
                icon: "flaticon2-map",
                page: "interestedPsychologists",
              },
              {
                title: "Registered Providers",
                root: true,
                icon: "flaticon2-avatar",
                page: "registeredPsychologists",
              },
              {
                title: "Referrers",
                root: true,
                icon: "flaticon2-avatar",
                page: "referrers",
              },
              {
                title: "Invited Clients",
                root: true,
                icon: "flaticon-download-1",
                page: "clientinvites",
              },
              {
                title: "Clients",
                root: true,
                icon: "flaticon2-user",
                bullet: "dot",
                submenu: [
                  {
                    title: "Psychology",
                    page: "psychologyclients",
                  },
                  {
                    title: "Provisional",
                    page: "provisionalclients",
                  },
                  { title: "Mental Health Nurse", page: "nurseclients" },
                  {
                    title: "Financial",
                    page: "financialclients",
                  },
                  {
                    title: "GP",
                    page: "gpclients",
                  },
                  {
                    title: "Supervision",
                    page: "supervisionclients",
                  },
                  {
                    title: "EAP/Contract",
                    page: "eapcontractclients",
                  },
                  {
                    title: "NthQLDPHN",
                    page: "nthqldphnclients",
                  },
                  {
                    title: "NDIS",
                    page: "ndisclients",
                  },
                  {
                    title: "Private",
                    page: "privateclients",
                  },
                  {
                    title: "Unassociated",
                    page: "unassociated",
                  },
                ],
              },
              {
                title: "Centralised Service",
                root: true,
                icon: "flaticon2-user",
                bullet: "dot",
                submenu: [
                  {
                    title: "Clients",
                    page: "csclients",
                  },
                  {
                    title: "Centres",
                    page: "cscentresadmin",
                  },
                  {
                    title: "Providers",
                    page: "csproviderlist",
                  },
                  {
                    title: "Staff",
                    page: "csagents",
                  },
                  { title: "Closures", page: "csclosuresadmin" },
                ],
              },
              {
                title: "Medical",
                root: true,
                icon: "flaticon2-hospital",
                bullet: "dot",
                submenu: [
                  {
                    title: "Medical Practitioners",
                    page: "medicalpractitioners",
                  },
                  {
                    title: "Practices",
                    page: "medicalpractices",
                  },
                ],
              },
              {
                title: "Provider Invoicing",
                root: true,
                icon: "flaticon2-shopping-cart",
                submenu: [
                  {
                    title: "Verify Provider",
                    page: "xeroverify",
                  },
                  {
                    title: "Gather All Bookings",
                    page: "gatherbillableall",
                  },
                  {
                    title: "Gather Provider Clients",
                    page: "gatherbillable",
                  },
                  {
                    title: "Gather Contract/EAP Clients",
                    page: "gathercontracts",
                  },
                  {
                    title: "Gather NthQLDPHN Clients",
                    page: "gathernthqldphn",
                  },
                  {
                    title: "Gather Contract by Provider",
                    page: "gathercontractsprovider",
                  },
                  {
                    title: "Generate Provider Invoices",
                    page: "invoices",
                  },
                  {
                    title: "Generate Contract/EAP Invoices",
                    page: "contractinv",
                  },
                  {
                    title: "Generate EAP Provider Payments",
                    page: "contractpay",
                  },
                  {
                    title: "Invoice Log",
                    page: "invoicelog",
                  },
                ],
              },
              {
                title: "Knowledge Base",
                root: true,
                icon: "flaticon2-website",
                submenu: [
                  {
                    title: "How To",
                    page: "howtoarticles",
                  },
                  {
                    title: "Resources",
                    page: "resources",
                  },
                  {
                    title: "Policies",
                    page: "policies",
                  },
                ],
              },
              {
                title: "Notifications",
                root: true,
                icon: "flaticon2-bell",
                page: "notifications",
              },
              {
                title: "My Profile",
                root: true,
                icon: "flaticon2-user-1",
                page: "adminprofile",
              },
              {
                title: "Log out",
                root: true,
                icon: "flaticon-logout",
                page: "logout",
              },
              {
                title: "System Configuration",
                root: true,
                icon: "flaticon2-document",
                submenu: [
                  {
                    title: "Admin Users",
                    page: "adminusers",
                  },
                  {
                    title: "Forms",
                    page: "forms",
                  },
                  {
                    title: "Maintain Service Codes",
                    page: "codes",
                  },
                  {
                    title: "Billing Services",
                    page: "billingservices",
                  },
                  {
                    title: "Archived Clients",
                    page: "recentarchived",
                  },
                  {
                    title: "Tags Setup",
                    page: "metadataconfig",
                  },
                  {
                    title: "Contract/EAP Setup",
                    page: "contracts",
                  },
                  {
                    title: "Opportunity Setup",
                    page: "opportunity",
                  },
                  {
                    title: "Program Setup",
                    page: "programs",
                  },
                  {
                    title: "Survey Setup",
                    page: "surveys",
                  },
                  {
                    title: "Survey Results",
                    page: "surveyresults",
                  },
                  {
                    title: "Provider Stats",
                    page: "providerstatistics",
                  },
                  {
                    title: "NthQLDPHN Stats",
                    page: "nthqldphnstatistics",
                  },
                  {
                    title: "Reporting Options",
                    page: "adminreporting",
                  },
                ],
              },
            ],
          },
        };
        return itemsAdmin;
      } else if (roleScope === "Psychiatrist") {
        const itemsAdmin = {
          header: {
            self: {},
            items: [],
          },
          aside: {
            self: {},
            items: [
              {
                title: "Welcome",
                root: true,
                icon: "flaticon2-architecture-and-city",
                page: "dashboard",
                bullet: "dot",
              },
              {
                title: "Clients",
                root: true,
                page: "csclients",
                icon: "flaticon2-user",
              },
              {
                title: "Registered Providers",
                root: true,
                icon: "flaticon2-avatar",
                page: "registeredProviders",
              },
              {
                title: "My Profile",
                root: true,
                icon: "flaticon2-user-1",
                page: "adminprofile",
              },
              {
                title: "Log out",
                root: true,
                icon: "flaticon2-circular-arrow",
                page: "logout",
              },
            ],
          },
        };
        return itemsAdmin;
      } else {
        const itemsAdmin = {
          header: {
            self: {},
            items: [],
          },
          aside: {
            self: {},
            items: [
              {
                title: "Dashboard",
                root: true,
                icon: "flaticon2-architecture-and-city",
                page: "dashboard",
                bullet: "dot",
              },
              {
                title: "Registered Providers",
                root: true,
                icon: "flaticon2-avatar",
                page: "registeredPsychologists",
              },
              {
                title: "Invited Clients",
                root: true,
                icon: "flaticon-download-1",
                page: "clientinvites",
              },
              {
                title: "Clients",
                root: true,
                icon: "flaticon2-user",
                page: "provisionalclients",
              },
              {
                title: "My Profile",
                root: true,
                icon: "flaticon2-user-1",
                page: "adminprofile",
              },
              {
                title: "Log out",
                root: true,
                icon: "flaticon-logout",
                page: "logout",
              },
            ],
          },
        };
        return itemsAdmin;
      }

    case "Psychologist":
      const itemsPsychologist = {
        header: {
          self: {},
          items: [],
        },
        aside: {
          self: {},
          items: [
            {
              title: "Dashboard",
              root: true,
              icon: "flaticon2-architecture-and-city",
              page: "dashboard",
              translate: "MENU.DASHBOARD",
              bullet: "dot",
            },
            {
              title: "Invited Clients",
              root: true,
              icon: "flaticon-download-1",
              page: "clientinvites",
            },
            {
              title: "Clients",
              root: true,
              icon: "flaticon2-map",
              page: "Clients",
            },
            {
              title: "Bookings",
              root: true,
              icon: "flaticon2-time",
              bullet: "dot",
              page: "bookings",
            },
            {
              title: "Tyro",
              root: true,
              icon: "flaticon2-shopping-cart",
              submenu: [
                {
                  title: "Maintain Service Codes",
                  page: "codes",
                },
                {
                  title: "Invoicing",
                  page: "invoices",
                },
              ],
            },
            {
              title: "Files",
              root: true,
              icon: "flaticon-file",
              bullet: "dot",
              page: "files",
            },
            {
              title: "Platform",
              root: true,
              icon: "flaticon2-document",
              bullet: "dot",
              page: "platform",
            },
            {
              title: "Forms",
              root: true,
              icon: "flaticon2-document",
              bullet: "dot",
              page: "forms",
            },
            {
              title: "Profile",
              root: true,
              icon: "flaticon2-gear",
              bullet: "dot",
              page: "profile",
            },
            {
              title: "Knowledge Base",
              root: true,
              icon: "flaticon2-website",
              submenu: [
                {
                  title: "How To",
                  page: "howtoarticles",
                },
                {
                  title: "Resources",
                  page: "resources",
                },
                {
                  title: "Policies",
                  page: "policies",
                },
              ],
            },
            {
              title: "Security",
              root: true,
              icon: "flaticon2-gear",
              bullet: "dot",
              page: "security",
            },
            {
              title: "Log out",
              root: true,
              icon: "flaticon2-circular-arrow",
              page: "logout",
            },
          ],
        },
      };
      return itemsPsychologist;

    case "Referrer":
      const itemsReferrer = {
        header: {
          self: {},
          items: [],
        },
        aside: {
          self: {},
          items: [
            {
              title: "Welcome",
              root: true,
              icon: "flaticon2-architecture-and-city",
              page: "dashboard",
              bullet: "dot",
            },
            {
              title: "Invited Clients",
              root: true,
              icon: "flaticon-download-1",
              page: "clientinvites",
            },
            {
              title: "Providers",
              root: true,
              icon: "flaticon2-map",
              bullet: "dot",
              page: "search",
            },
            {
              title: "Profile",
              root: true,
              icon: "flaticon2-gear",
              bullet: "dot",
              page: "profile",
            },
            {
              title: "Log out",
              root: true,
              icon: "flaticon2-circular-arrow",
              page: "logout",
            },
          ],
        },
      };
      return itemsReferrer;

    case "CS":
      const itemsCS = {
        header: {
          self: {},
          items: [],
        },
        aside: {
          self: {},
          items: [
            {
              title: "Welcome",
              root: true,
              icon: "flaticon2-architecture-and-city",
              page: "dashboard",
              bullet: "dot",
            },
            {
              title: "Clients",
              root: true,
              page: "csclients",
              icon: "flaticon2-user",
            },
            {
              title: "Providers",
              root: true,
              icon: "flaticon2-map",
              page: "csproviderlist",
            },
            {
              title: "Profile",
              root: true,
              icon: "flaticon2-gear",
              bullet: "dot",
              page: "profile",
            },
            {
              title: "Knowledge Base",
              root: true,
              icon: "flaticon2-website",
              submenu: [
                {
                  title: "How To",
                  page: "howtoarticles",
                },
                {
                  title: "Resources",
                  page: "resources",
                },
                {
                  title: "Policies",
                  page: "policies",
                },
              ],
            },

            {
              title: "Log out",
              root: true,
              icon: "flaticon2-circular-arrow",
              page: "logout",
            },
          ],
        },
      };
      return itemsCS;

    case "CSAdmin":
      const itemsCSAdmin = {
        header: {
          self: {},
          items: [],
        },
        aside: {
          self: {},
          items: [
            {
              title: "Welcome",
              root: true,
              icon: "flaticon2-architecture-and-city",
              page: "dashboard",
              bullet: "dot",
            },
            {
              title: "My Centre",
              page: "cscentres",
              root: true,
              icon: "flaticon2-architecture-and-city",
            },
            {
              title: "Clients",
              page: "csclients",
              root: true,
              icon: "flaticon2-user",
            },
            {
              title: "Staff",
              page: "csagents",
              root: true,
              icon: "flaticon2-user",
            },
            {
              title: "Providers",
              root: true,
              icon: "flaticon2-map",
              page: "csproviderlist",
            },
            {
              title: "Profile",
              root: true,
              icon: "flaticon2-gear",
              page: "profile",
            },
            {
              title: "Knowledge Base",
              root: true,
              icon: "flaticon2-website",
              submenu: [
                {
                  title: "How To",
                  page: "howtoarticles",
                },
                {
                  title: "Resources",
                  page: "resources",
                },
                {
                  title: "Policies",
                  page: "policies",
                },
              ],
            },

            {
              title: "Log out",
              root: true,
              icon: "flaticon2-circular-arrow",
              page: "logout",
            },
          ],
        },
      };
      return itemsCSAdmin;

    default:
  }
}
